module.exports = __webpack_public_path__ + "static/media/mobile-overlay-close.6706167c.png";